import React from 'react';
import { AnonymizedPortfolios, PortfolioAccessRequests, IdentityMapping, RoleManagement, AuditLog } from '../AdminRBACTabs';
import AdminAssistedOnboarding from '../AdminAssistedOnboarding';
import AdminWalkthroughVideos from '../AdminWalkthroughVideos';
import AdminBetaManagement from '../AdminBetaManagement';
import CodeHealthDashboard from '../CodeHealthDashboard';
import HealthCheckPanel from '../HealthCheckPanel';
import { AdminAdvisorManagement } from '../AdminAdvisorManagement';
import { AdminFeedbackPanel } from '../AdminFeedbackPanel';
import BackupStatusPanel from '../BackupStatusPanel';
import { CampaignsHistory } from './CampaignsHistory';

const TabSection = ({ children, dark }) => (
  <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 pb-8">
    {dark ? <div className="bg-gray-800 rounded-xl p-3 sm:p-6 border border-gray-700">{children}</div> : children}
  </div>
);

const DarkTitledSection = ({ title, children }) => (
  <TabSection dark>
    <h3 className="text-lg sm:text-xl font-bold text-white mb-4">{title}</h3>
    {children}
  </TabSection>
);

const TAB_RENDERERS = {
  'portfolios': (admin) => <DarkTitledSection title="Anonymized User Portfolios"><AnonymizedPortfolios adminRole={admin?.role} /></DarkTitledSection>,
  'portfolio-access': (admin) => <DarkTitledSection title="Portfolio Access Requests"><PortfolioAccessRequests adminRole={admin?.role} /></DarkTitledSection>,
  'identity-map': () => <DarkTitledSection title="Identity Mapping"><IdentityMapping /></DarkTitledSection>,
  'roles': () => <DarkTitledSection title="Role Management"><RoleManagement /></DarkTitledSection>,
  'audit-log': (admin) => <DarkTitledSection title="Audit Log"><AuditLog adminRole={admin?.role} /></DarkTitledSection>,
  'feedback': () => <TabSection><AdminFeedbackPanel /></TabSection>,
  'advisors': () => <TabSection><AdminAdvisorManagement /></TabSection>,
  'assisted-onboarding': () => <TabSection dark><AdminAssistedOnboarding adminToken={localStorage.getItem('auth_token')} /></TabSection>,
  'walkthrough-videos': () => <TabSection dark><AdminWalkthroughVideos adminToken={localStorage.getItem('auth_token')} /></TabSection>,
  'beta-program': () => <TabSection dark><AdminBetaManagement /></TabSection>,
  'campaigns': () => <TabSection><CampaignsHistory /></TabSection>,
  'health-check': () => <TabSection><HealthCheckPanel /></TabSection>,
  'code-health': () => <TabSection><CodeHealthDashboard /></TabSection>,
  'backups': () => <TabSection dark><BackupStatusPanel /></TabSection>,
};

const ROLE_REQUIREMENTS = {
  'identity-map': ['owner'],
  'audit-log': ['owner', 'infosec'],
  'feedback': ['owner', 'admin', 'engineer', 'product_manager'],
  'advisors': ['owner', 'admin'],
  'assisted-onboarding': ['owner', 'admin', 'support'],
  'walkthrough-videos': ['owner', 'admin'],
  'beta-program': ['owner', 'admin'],
  'campaigns': ['owner', 'admin', 'support'],
  'health-check': ['owner', 'admin'],
  'code-health': ['owner', 'admin'],
  'backups': ['owner', 'admin', 'engineer'],
};

export const AdminRoleTabContent = ({ activeTab, admin, isRoleAllowed }) => {
  const renderer = TAB_RENDERERS[activeTab];
  if (!renderer) return null;
  const roles = ROLE_REQUIREMENTS[activeTab];
  if (roles && !isRoleAllowed(roles)) return null;
  return renderer(admin);
};
